import { Grid, Typography } from '@mui/material'
import { AppBox, AppCheckBox, AppTypography } from 'components'
import { AppSelect } from 'components/base/select/AppSelect'
import { getMDYFormattedDate } from 'globals/functions'
import { useMembershipHelper } from 'hooks'
import { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'

interface Props {
  isFormFilled: (val: boolean) => void
  onLengthChange: (val: string) => void
}

export const PauseMembershipVerification: FC<Props> = ({ isFormFilled, onLengthChange }) => {
  const {
    control,
    watch,
    formState: { isValid },
  } = useForm<{
    duration: string
    pauseTimeAgreed: boolean
    userPauseAgreed: boolean
  }>()
  const { CurrentMembership } = useMembershipHelper()

  const pauseLengthOptions = [
    {
      label: '1 Month pause',
      value: '1',
    },
    {
      label: '2 Month pause',
      value: '2',
    },
    {
      label: '3 Month pause',
      value: '3',
    },
    {
      label: '4 Month pause',
      value: '4',
    },
    {
      label: '5 Month pause',
      value: '5',
    },
    {
      label: '6 Month pause',
      value: '6',
    },
  ]
  useEffect(() => {
    isFormFilled(isValid)
  }, [watch()])
  return (
    <AppBox>
      <AppTypography fontSize={32} fontWeight={700} textAlign={'center'}>
        Tell us how long to pause your bill
      </AppTypography>
      <AppBox paddingX={2} paddingTop={2}>
        <Typography fontSize={16} fontWeight={'bold'}>
          Reason of Cancelling
        </Typography>
        <Typography color={'grey.500'} fontSize={14}>
          Tell us how long to pause your subscription plan once your current billing cycle ends. We’ll be sure to
          automatically restart your plan once your chosen time period expires.
        </Typography>
        <Grid item xs={6} paddingY={2}>
          <AppSelect
            control={control}
            name="duration"
            options={pauseLengthOptions}
            label="Select Length of Pause"
            placeholder="Length of Pause"
            required
            onFieldChange={(e) => onLengthChange(e.target.value)}
          />
        </Grid>
        <AppCheckBox
          required
          control={control}
          name="pauseTimeAgreed"
          label={
            'Pause my subscription plan when my current billing cycle ends on ' +
            getMDYFormattedDate(new Date(CurrentMembership()?.CurrentPeriodEnd ?? ''))
          }
        />
        <AppCheckBox
          required
          control={control}
          name="userPauseAgreed"
          label="I understand that pausing my subscription plan will pause all of my plan’s users."
        />
      </AppBox>
    </AppBox>
  )
}
